import { useQuery } from "@tanstack/react-query";

import { api } from "./api";
import type { User } from "./types";

export function useSession() {
  return useQuery({
    queryKey: ["session"],
    queryFn: () => api<{ user: User | null }>("/auth/session/"),
    staleTime: 60_000,
    retry: false,
  });
}
